export const environment = {
  production: true,
  development: false,
  test: false,
  brand: 'VYV',
  apiConfig: {
    scopes: ['api://boiard-dev-back-office/Read.All', 'api://boiard-dev-back-office/Write.All'],
    uri: 'https://dev.assurance.vyv-conseil.fr/api/',
  },
  keycloak: {
    url: 'https://rec.authentification.harmonie-mutuelle.fr/auth',
    realm: 'adherents_rec3',
    clientId: 'vyvconseil_rec3',
    tokenEndpoint: 'authentication/token/hm',
  },
  passConnect: {
    url: 'https://passconnect-preprod.groupe-vyv.fr/auth',
    realm: 'passconnect',
    clientId: 'sequoia-adherent-test',
    tokenEndpoint: 'authentication/token/passconnect',
  },
  appInsightsConfig: {
    connectionString: 'InstrumentationKey=f409faaf-8841-41c5-aa3f-a35a34bc220d;IngestionEndpoint=https://francecentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://francecentral.livediagnostics.monitor.azure.com/;ApplicationId=2a329dbb-97ac-4c7b-959a-5c851b2cd82c',
    maxBatchIntervalMs: '15000',
  },
  ParcoursDeSouscription: {
    AHC: 'https://dev.assurance-habitation.vyv-conseil.fr/product/HC',
    AHP: 'https://dev.assurance-habitation.vyv-conseil.fr/product/HP',
    AHS: 'https://dev.assurance-habitation.vyv-conseil.fr/product/HS',
    AHT: 'https://dev.assurance-habitation.vyv-conseil.fr/product/HT',
  },
  EspaceAdherentUrl: {
    MGEN: "https://www.mgen.fr/login-adherent/",
    HM: "https://harmonie-et-moi.fr/",
    MNT: "https://adherents.mnt.fr/"
  },
  Systempay: {
    endpoint: 'https://api.systempay.fr',
    publicKey: '73852400:testpublickey_HbYVxnyDUy7eCiCL0OK9l8b8PJRG6suXyVpxzdsM1v6cv',
  },
   msalConfig: {
    auth: {
      clientId: 'd2ff996d-5b61-4d3c-8c3d-f834866405c3',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
    },
    enabled: 'true',
  },
};
